import Core             from "@/core/Core";
import DeliveryTypesDAO from "@/domains/DeliveryTypes/DeliveryTypesDAO";
import DeliveryType     from "@/domains/DeliveryTypes/DeliveryType";
import Dictionary       from "@/core/types/Dictionary";

class DeliveryTypesService {

	/**
	 * Кеш типов доставки. Наполняется из Dictionaries общим эндпоинтом.
	 * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
	 */
	static deliveryTypes = reactive(new Dictionary<string, DeliveryType>());

	static async getList(): Promise<DeliveryType[]> {
		const response = await DeliveryTypesDAO.getList();

		return Core.utils.hydrateArray(response.data, DeliveryType.fromServer);
	}

	/**
	 * Список типов доставки, доступных покупателю (т.е. без вариантов «силами продавца»).
	 * Раньше фильтровалось строковым префиксом id ('bySeller*') — теперь по типизированному
	 * полю DeliveryType.isAccessibleBy.buyer. Используется в карточках сборки и подобных
	 * местах, где доставку выбирает покупатель.
	 *
	 * Источник — словарь Core.dictionaries.deliveryTypes (синхронный кеш на старте приложения).
	 * Позже кеш переедет внутрь сервиса — сигнатура метода не изменится.
	 */
	static getListAccessibleByBuyer(): DeliveryType[] {
		return this.deliveryTypes.filter(dt => dt.isAccessibleBy?.buyer === true);
	}

	/**
	 * Типы доставки для прямых заказов: силами продавца или покупателя.
	 * Платформа не доставляет прямые заказы — она существует только для isOfferBased: true.
	 */
	static getListForDirectOrders(): DeliveryType[] {
		return this.deliveryTypes.filter(dt => dt.isAccessibleBy?.seller === true || dt.isAccessibleBy?.buyer === true);
	}

	/**
	 * Типы доставки для позиции заказа.
	 * Для позиций на основе предложения — все типы, иначе — без доставки платформой (byETP).
	 */
	static getListForOrderPosition(isOfferBased: boolean): DeliveryType[] {
		if (isOfferBased) {
			return this.deliveryTypes.toArray();
		}
		else {
			return this.deliveryTypes.filter(dt => dt.id !== 'byETP');
		}
	}
}

export default DeliveryTypesService;